'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _bem = require('../lib/bem');

var _resize = require('../lib/resize');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var TabContent = function (_PureComponent) {
    _inherits(TabContent, _PureComponent);

    function TabContent(props, context) {
        _classCallCheck(this, TabContent);

        var _this = _possibleConstructorReturn(this, (TabContent.__proto__ || Object.getPrototypeOf(TabContent)).call(this, props, context));

        _this.state = { fastTransition: false, height: null };

        _this.getRef = _this.getRef.bind(_this);
        _this.onResize = _this.onResize.bind(_this);
        _this.update = _this.update.bind(_this);
        return _this;
    }

    _createClass(TabContent, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            this.context.bem.subscribe(this);
            this.context.tabbordionPanel.subscribe(this);
            // add reference here to reduce unnecessary references server side
            this.onResize.getState = this.context.tabbordionPanel.getState;
            (0, _resize.addResizeListener)(this.onResize);
        }
    }, {
        key: 'componentDidUpdate',
        value: function componentDidUpdate() {
            this.update();
        }
    }, {
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(props, context) {
            // this should not happen but we know bugs happen when unexpected things happen
            if (context.tabbordionPanel !== this.context.tabbordionPanel) {
                this.onResize.getState = context.tabbordionPanel.getState;
            }
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            (0, _resize.removeResizeListener)(this.onResize);

            this.context.bem.unsubscribe(this);
            this.context.tabbordionPanel.unsubscribe(this);
        }
    }, {
        key: 'getRef',
        value: function getRef(child) {
            this.child = child;
        }
    }, {
        key: 'onResize',
        value: function onResize() {
            this.update('resize');
        }
    }, {
        key: 'update',
        value: function update(triggerer) {
            var _this2 = this;

            if (!this.child) {
                return;
            }

            var _child$getBoundingCli = this.child.getBoundingClientRect(),
                bottom = _child$getBoundingCli.bottom,
                top = _child$getBoundingCli.top;

            var height = Math.ceil(bottom - top);
            var fastTransition = this.state.fastTransition;

            if (this.state.height !== height) {
                // make all transitions go faster to give smoother experience
                if (triggerer === 'resize') {
                    fastTransition = true;
                }

                this.setState({ fastTransition: fastTransition, height: height });
            }
            // kills the previous timeout after each resize event so that fast mode is alive until after last resize event
            if (triggerer === 'resize' && fastTransition) {
                clearTimeout(this._dtt);
                this._dtt = setTimeout(function () {
                    delete _this2._dtt;
                    _this2.setState({ fastTransition: false });
                }, 500);
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var _props = this.props,
                children = _props.children,
                className = _props.className,
                Component = _props.component,
                style = _props.style,
                props = _objectWithoutProperties(_props, ['children', 'className', 'component', 'style']);

            var _context$bem$getState = this.context.bem.getState(),
                bemSeparator = _context$bem$getState.bemSeparator,
                blockElements = _context$bem$getState.blockElements;

            var _context$tabbordionPa = this.context.tabbordionPanel.getState(),
                animateContent = _context$tabbordionPa.animateContent,
                checked = _context$tabbordionPa.checked,
                contentId = _context$tabbordionPa.contentId,
                inputId = _context$tabbordionPa.inputId,
                modifiers = _context$tabbordionPa.modifiers;

            var panelBem = (0, _bem.bemClassName)(blockElements, 'content', modifiers, bemSeparator);
            var animatorBem = (0, _bem.bemClassName)(blockElements, 'animator', modifiers, bemSeparator);

            var height = animateContent === 'height' ? checked ? this.state.height && this.state.height + 'px' || 'auto' : '0px' : null;

            var marginTop = animateContent === 'marginTop' ? !checked ? this.state.height && -this.state.height + 'px' || '-65535px' : '0px' : null;

            var resizeStyle = this.state.fastTransition ? {
                webkitTransition: 'all 32ms',
                transition: 'all 32ms'
            } : null;

            // contentId will be overwritten by props.id (intended behavior)
            return animateContent ? _react2.default.createElement(
                Component,
                _extends({
                    id: contentId
                }, props, {
                    'aria-labelledby': inputId,
                    className: !animatorBem ? className : className ? animatorBem + ' ' + className : animatorBem,
                    role: 'tabpanel',
                    style: _extends({}, style, {
                        height: height,
                        overflow: checked && animateContent === 'marginTop' ? 'visible' : 'hidden'
                    }, resizeStyle)
                }),
                _react2.default.createElement(
                    'div',
                    { ref: this.getRef, className: panelBem, style: marginTop && _extends({ marginTop: marginTop }, resizeStyle) },
                    children
                )
            ) : _react2.default.createElement(
                Component,
                _extends({
                    id: contentId
                }, props, {
                    'aria-labelledby': inputId,
                    className: !panelBem ? className : className ? panelBem + ' ' + className : panelBem,
                    ref: this.getRef,
                    role: 'tabpanel',
                    style: style
                }),
                children
            );
        }
    }]);

    return TabContent;
}(_react.PureComponent);

TabContent.hasContent = true;

TabContent.contextTypes = {
    bem: _propTypes2.default.object,
    tabbordionPanel: _propTypes2.default.object
};

TabContent.defaultProps = {
    component: 'div'
};

TabContent.propTypes = {
    children: _propTypes2.default.node,
    className: _propTypes2.default.string,
    component: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.object, _propTypes2.default.string]),
    style: _propTypes2.default.object
};

exports.default = TabContent;


//////////////////
// WEBPACK FOOTER
// ./~/react-tabbordion/dist/module/components/TabContent.js
// module id = 678
// module chunks = 0